import api from 'services/api';
import { trackEvent } from 'tracking/GA';
import { ACTIONS, CATEGORIES } from 'tracking/GA/constants';
import get from 'lodash/get';
import {
  SCHEDULE_FETCHING,
  SCHEDULE_FAIL,
  RUN_SCHEDULE,
  SCHEDULED_AGENTS_GET_DATA,
  SCHEDULE_SET_IS_CREATE,
  SCHEDULER_UNSELECTED,
  SCHEDULER_SELECTED,
  SCHEDULER_NEW_PIVOT,
  UNSELECT_ALL_SCHEDULER,
  SELECT_ALL_SCHEDULER,
  SCHEDULE_SET_SECTION,
  SCHEDULER_CLEAR_ERROR,
  GET_SCHEDULERS_COUNT_SUCCESS,
  SCHEDULE_SET_TAGS_ENTITY,
  SCHEDULE_RESET_TAGS_FIELDS,
  SCHEDULED_CLOUD_AGENTS_GET_DATA,
  SCHEDULE_RESET_STATE,
  GET_USER_AGENTS_FOR_SCHEDULER,
  GET_CLOUD_AGENTS_FOR_SCHEDULER,
  ADD_TAGS_TO_SCHEDULER,
  SCHEDULER_RESET_TAGS,
  SCHEDULER_DETAIL,
  SCHEDULER_RESET_DETAIL
} from './constants';
import {
  selectData,
  selectIsFetching,
  selectLastSelected,
  selectSchedulersSelected,
  selectSchedulersTotal,
  selectSelectedSection
} from './selectors';
import { setFiedsError } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { selectAdvancedFilterQueryParam, selectQueryParam, selectRowsPerPage } from 'store/Filters/selectors';
import { setOrderBy, setPageNumber } from 'store/Filters/actions';

export const resetState = () => (dispatch) => dispatch({ type: SCHEDULE_RESET_STATE });

export function fetching (section) {
  return async (dispatch, getState) => {
    const isFetching = selectIsFetching(getState(), section);
    if (!isFetching) dispatch({ type: SCHEDULE_FETCHING, isFetching: true, section });
  };
}

export function somethingWentWrong (message) {
  return async (dispatch, getState) => {
    const section = selectSelectedSection(getState());
    dispatch({ type: SCHEDULE_FAIL, message, section });
  };
}

export function getSchedules () {
  return async (dispatch, getState) => {
    const section = 'scheduledAgents';
    try {
      dispatch(fetching(section));
      let advancedFilterQueryParam = [];

      try {
        advancedFilterQueryParam = selectAdvancedFilterQueryParam(getState(), 'scheduler');
      } catch (e) {
        dispatch(setFiedsError('scheduler', 'Syntax error. Please try again. For further help check our documentation'));
      }
      const hasAdvancedFilter = advancedFilterQueryParam.filters.length > 0;
      const standardQueryParam = selectQueryParam('scheduler', getState());
      const queryParam = hasAdvancedFilter ? advancedFilterQueryParam : standardQueryParam;

      const schedulers = await api.schedule.fetchSchedules(queryParam);
      dispatch({ type: SCHEDULED_AGENTS_GET_DATA, data: schedulers?.rows, total: schedulers?.total_rows });
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function getCloudSchedules () {
  return async (dispatch, getState) => {
    const section = 'scheduledCloudAgents';
    try {
      dispatch(fetching(section));
      let advancedFilterQueryParam = [];

      try {
        advancedFilterQueryParam = selectAdvancedFilterQueryParam(getState(), 'cloudScheduler');
      } catch (e) {
        dispatch(setFiedsError('cloudScheduler', 'Syntax error. Please try again. For further help check our documentation'));
      }
      const hasAdvancedFilter = advancedFilterQueryParam.filters.length > 0;
      const standardQueryParam = selectQueryParam('cloudScheduler', getState());
      const queryParam = hasAdvancedFilter ? advancedFilterQueryParam : standardQueryParam;

      const schedulers = await api.schedule.fetchCloudSchedules(queryParam);
      dispatch({ type: SCHEDULED_CLOUD_AGENTS_GET_DATA, data: schedulers?.rows, total: schedulers?.total_rows });
    } catch (e) {
      dispatch(somethingWentWrong(section));
    }
  };
}

export const getCountSchedulers = () => async (dispatch) => {
  try {
    const response = await api.schedule.fetchCountSchedulers();
    dispatch({ type: GET_SCHEDULERS_COUNT_SUCCESS, response });
  } catch (e) {
    dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
  }
};

export function sortBySchedulers (orderBy) {
  return async (dispatch, getState) => {
    const section = selectSelectedSection(getState());
    const entity = section === 'scheduledAgents' ? 'scheduler' : 'cloudScheduler';
    dispatch(setOrderBy(entity, orderBy));
    if (section === 'scheduledAgents') dispatch(getSchedules());
    else dispatch(getCloudSchedules());
  };
}

export function setPage (page, section) {
  return async (dispatch) => {
    const entity = section === 'scheduledAgents' ? 'scheduler' : 'cloudScheduler';
    dispatch(setPageNumber(entity, page));
    if (section === 'scheduledAgents') dispatch(getSchedules());
    else dispatch(getCloudSchedules());
  };
}

export const setIsCreateSchedule = (value) => (dispatch) => {
  dispatch({ type: SCHEDULE_SET_IS_CREATE, value });
};

const addDeleteController = (schedulers, schedulersList) => {
  const allSchedulersAreSelected = schedulers.every(testScheduler => schedulersList.some((scheduler) => scheduler.value.id === testScheduler.value.id));

  if (allSchedulersAreSelected) return [SCHEDULER_UNSELECTED, schedulers];
  return [SCHEDULER_SELECTED, schedulers];
};

const selectCalculator = (e, scheduler, schedulersList, areSchedulerSelected) => (dispatch, getState) => {
  const pivot = selectLastSelected(getState());
  const index = schedulersList.findIndex((el) => el.value.id === scheduler.value.id);
  const schedulersSelected = selectSchedulersSelected(getState());

  dispatch({ type: SCHEDULER_NEW_PIVOT, payload: index });
  if (e.shiftKey && pivot !== -1 && areSchedulerSelected) {
    const start = Math.min(pivot, index);
    const end = Math.max(pivot, index) + 1;
    const schedulers = schedulersList.slice(start, end);
    const [type, payload] = addDeleteController(schedulers, schedulersSelected);
    return dispatch({ type, payload });
  }
  const [type, payload] = addDeleteController([scheduler], schedulersSelected);
  return dispatch({ type, payload });
};

export const selectRow = (e, scheduler) => (dispatch, getState) => {
  const section = selectSelectedSection(getState());
  const allSchedulers = selectData(getState(), section);
  const schedulerSelected = selectSchedulersSelected(getState());
  dispatch(selectCalculator(e, scheduler, allSchedulers, schedulerSelected.length > 0));
};

export const unSelectAll = () => (dispatch) => dispatch({ type: UNSELECT_ALL_SCHEDULER });

export const selectAllScheduler = () => (dispatch, getState) => {
  const section = selectSelectedSection(getState());
  const entity = section === 'scheduledAgents' ? 'scheduler' : 'cloudScheduler';
  const schedulersList = selectData(getState(), section);
  const schedulersSelected = selectSchedulersSelected(getState());
  const schedulerCount = selectSchedulersTotal(getState(), section);
  const pageSize = selectRowsPerPage(entity, getState());

  if (schedulersSelected.length === schedulerCount || schedulersSelected.length >= pageSize) return dispatch(unSelectAll());

  return dispatch({ type: SELECT_ALL_SCHEDULER, schedulersList });
};

export const selectScheduler = (scheduler) => (dispatch) => {
  dispatch({ type: SCHEDULER_SELECTED, payload: [scheduler] });
};

export const setSection = (section) => (dispatch) => {
  dispatch({ type: SCHEDULE_SET_SECTION, section });
  dispatch(unSelectAll());
};
export function changeStatus (scheduleId, status, type) {
  return async (dispatch) => {
  // if (status && selectLimitReached(getState())) { comento esto por ahora porque no deberia validar el limite cuando se activa/desactiva
  // dispatch(openModal(MODAL_UPGRADE_LICENSE));
  // } else {
    dispatch(fetching());
    if (type === 'cloud_agent') {
      await api.schedule.changeStatusCloud(scheduleId, status);
      dispatch(getCloudSchedules());
    } else {
      await api.schedule.changeStatus(scheduleId, status);
      dispatch(getSchedules());
    }

    // }
  };
}

export function removeSchedule () {
  return async (dispatch, getState) => {
    try {
      const section = selectSelectedSection(getState());
      dispatch(fetching());
      const schedulersSelected = selectSchedulersSelected(getState());

      await Promise.all(schedulersSelected.map(async (row) => {
        await api.schedule.removeSchedule(row.id);
        dispatch(trackEvent(CATEGORIES.schedule, ACTIONS.deleteSchedule.name, ACTIONS.deleteSchedule.label, row.id));
      }));
      dispatch(unSelectAll());
      if (section === 'scheduledAgents') {
        dispatch(getSchedules());
      } else {
        dispatch(getCloudSchedules());
      }
      dispatch(getCountSchedulers());
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function runSchedule (id, type) {
  return async (dispatch) => {
    try {
      if (type === 'cloud_agent') {
        await api.schedule.runCloudSchedule(id);
      } else {
        await api.schedule.runSchedule(id);
      }
      dispatch({ type: RUN_SCHEDULE, id });
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function setTagsInScheduler (data) {
  return (dispatch) => {
    dispatch({ type: SCHEDULE_SET_TAGS_ENTITY, data });
  };
}

export function resetTagsFields () {
  return (dispatch) => {
    dispatch({ type: SCHEDULE_RESET_TAGS_FIELDS });
  };
}

export function saveSchedule (scheduleId, agentId, crontabName, active, crontab, description, executorId, parameters, workspaces, timezone, tags, type, severityRange) {
  return async (dispatch) => {
    try {
      dispatch(fetching());
      const min_severity = severityRange?.min.severity?.toUpperCase();
      const max_severity = severityRange?.max.severity?.toUpperCase();
      const hostTags = get(tags, 'host_tag', []);
      const vulnsTags = get(tags, 'vuln_tag', []);
      const servicesTags = get(tags, 'service_tag', []);
      const host_tag = hostTags.map((t) => t.name || t);
      const vuln_tag = vulnsTags.map((t) => t.name || t);
      const service_tag = servicesTags.map((t) => t.name || t);
      if (type === 'cloud_agent') {
        if (scheduleId === 0) {
          const response = await api.schedule.createCloudSchedule(agentId, crontabName, crontab, active, description, parameters, workspaces, timezone, host_tag, vuln_tag, service_tag, min_severity, max_severity);
          dispatch(trackEvent(CATEGORIES.schedule, ACTIONS.createSchedule.name, ACTIONS.createSchedule.label, response.id));
        } else {
          await api.schedule.updateCloudSchedule(scheduleId, agentId, crontabName, crontab, active, description, parameters, workspaces, timezone, host_tag, vuln_tag, service_tag, min_severity, max_severity);
          dispatch(trackEvent(CATEGORIES.schedule, ACTIONS.editSchedule.name, ACTIONS.editSchedule.label, scheduleId));
          dispatch(unSelectAll());
        }
        dispatch(getCloudSchedules());
      } else {
        if (scheduleId === 0) {
          const response = await api.schedule.createSchedule(agentId, crontabName, active, crontab, description, executorId, JSON.stringify(parameters), workspaces, timezone, host_tag, vuln_tag, service_tag, min_severity, max_severity);
          dispatch(trackEvent(CATEGORIES.schedule, ACTIONS.createSchedule.name, ACTIONS.createSchedule.label, response.id));
        } else {
          await api.schedule.updateSchedule(scheduleId, agentId, crontabName, active, crontab, description, executorId, JSON.stringify(parameters), workspaces, timezone, host_tag, vuln_tag, service_tag, min_severity, max_severity);
          dispatch(trackEvent(CATEGORIES.schedule, ACTIONS.editSchedule.name, ACTIONS.editSchedule.label, scheduleId));
          dispatch(unSelectAll());
        }
        dispatch(getSchedules());
      }
      dispatch(getCountSchedulers());
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function clearError (section) {
  return async (dispatch) => {
    dispatch({ type: SCHEDULER_CLEAR_ERROR, section });
  };
}

export function getAllUserAgents () {
  return async (dispatch) => {
    try {
      const userAgents = await api.agents.fetchAllUserAgents();
      dispatch({ type: GET_USER_AGENTS_FOR_SCHEDULER, userAgents: get(userAgents, 'rows', []) });
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function getAllCloudAgents () {
  return async (dispatch) => {
    try {
      const cloudAgents = await api.agents.fetchAllCloudAgents();
      dispatch({ type: GET_CLOUD_AGENTS_FOR_SCHEDULER, cloudAgents: get(cloudAgents, 'rows', []) });
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export const addTagsToScheduler = (data) => (dispatch) => {
  dispatch({ type: ADD_TAGS_TO_SCHEDULER, data });
};

export const resetTagsInScheduler = () => (dispatch) => {
  dispatch({ type: SCHEDULER_RESET_TAGS });
};

export const setSchedulerDetail = (scheduler) => (dispatch) => {
  dispatch({ type: SCHEDULER_DETAIL, scheduler });
};

export const resetDetail = () => (dispatch) => {
  dispatch({ type: SCHEDULER_RESET_DETAIL });
};
